<template>
    <default-layout>
        <div class="row">
            <div class="col-12">
                <div class="btn-toolbar float-right" role="toolbar" aria-label="Orders toolbar">
                    <div class="btn-group mr-2" role="group" aria-label="Orders toolbar, first group">
                        <button type="button" class="btn-sm page-link mr-2" @click="onRefresh">
                            <font-awesome-icon class="mr-1" icon="sync"/>
                            Refresh
                        </button>
                        <button type="button" class="btn-sm page-link" @click="exportCsv" title="Export CSV">
                            <font-awesome-icon class="mr-1" icon="file-csv"/>
                            Export CSV
                        </button>
                    </div>
                </div>
                <h1 class="h4 mb-4 clearfix">
                    Licenses
                    <span class="badge badge-pill badge-primary" v-if="licenses.total">{{ licenses.total }}</span>
                </h1>
            </div>
        </div>

        <div class="row" v-if="loading === false && keyNaveModule.status.listLicensesComplete === false">
            <div class="col-12">
                <spinner-component class="p-5" type="spinner-grow"/>
            </div>
        </div>

        <div class="row" v-if="loading === false && keyNaveModule.status.listLicensesComplete === true">

            <div class="col-12">
                <form class="form-inline mb-4" @submit.prevent="onRefresh">
                    <div class="form-group mr-2">
                        <input class="form-control form-control-sm" type="text" placeholder="Search..." v-model="filter[0].value">
                    </div>
                    <button type="submit" class="btn btn-sm btn-primary">Search</button>
                </form>
            </div>


            <div class="col-12 clearfix">
                <pagination-component :page="page" :limit="limit" :total="licenses.total" @paginate="onChangePage"/>

                <div class="btn-toolbar float-right" role="toolbar" aria-label="Licenses table per page">
                    <div class="btn-group mr-2" role="group" aria-label="Licenses toolbar, first group">
                        <form class="form-inline mb-4" @change="onRefresh">
                            <div class="form-group">
                                <label class="mr-2" for="licenses-per-page">
                                    <small>Licenses per page</small>
                                </label>
                                <select id="licenses-per-page" class="form-control form-control-sm" v-model="limit">
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="75">75</option>
                                    <option value="100">100</option>
                                    <option value="500">500</option>
                                </select>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="table-responsive">
                    <table id="licenses-table" class="table">
                        <thead>
                        <tr>
                            <th>License Code</th>
                            <th>Type</th>
                            <th>Status</th>
                            <th>Purchase Date</th>
                            <th>Activation Date</th>
                            <th>Reseller License Count</th>
                            <th>Estimated Usage</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="license of licenses.list" :key="license.id">
                            <td class="align-middle">
                                {{ license.licenseCode }}
                            </td>
                            <td class="align-middle">
                                <span v-if="license.type === 'LICENSE_DEFAULT'" class="badge badge-light">
                                    Default
                                </span>
                                <span v-else-if="license.type === 'LICENSE_RESELLER'" class="badge badge-info">
                                    Reseller
                                </span>
                                <span v-else class="badge badge-secondary">
                                    {{ license.type }}
                                </span>
                            </td>
                            <td class="align-middle">
                                <span v-if="license.status === 'LICENSE_USED'" class="badge badge-warning">
                                    Used
                                </span>
                                <span v-else-if="license.status === 'LICENSE_ASSIGNED'" class="badge badge-success">
                                    Assigned
                                </span>
                                <span v-else-if="license.status === 'LICENSE_UNASSIGNED'" class="badge badge-light">
                                    Unassigned
                                </span>
                                <span v-else-if="license.status === 'LICENSE_CANCELLED'" class="badge badge-danger">
                                    Cancelled
                                </span>
                                <span v-else-if="license.status === 'LICENSE_ACTIVE'" class="badge badge-info">
                                    Active
                                </span>
                                <span v-else-if="license.status === 'LICENSE_WATCHING'" class="badge badge-dark">
                                    <font-awesome-icon class="mr-1 small fa-blink" icon="play"/>
                                    Watching
                                </span>
                                <span v-else class="badge badge-secondary">
                                    {{ license.status }}
                                </span>
                            </td>
                            <td class="align-middle">
                                <span v-if="license.purchaseDate">
                                    {{ moment(license.purchaseDate).format('DD.MM.YYYY') }}
                                </span>
                            </td>
                            <td class="align-middle">
                                <span v-if="license.activationDate">
                                    {{ moment(license.activationDate).format('DD.MM.YYYY') }}
                                </span>
                            </td>
                            <td class="align-middle">
                                <span v-if="license.resellerLicenseCount">
                                    {{ license.resellerLicenseCount }}
                                </span>
                            </td>
                            <td class="align-middle">
                                <span v-if="license.playoutUsageDataEstimation && license.playoutUsageDataEstimation !== -1">
                                    Data: {{ license.playoutUsageDataEstimation | formatBytes }}
                                </span><br>
                                <span v-if="license.playoutUsageTimeEstimation && license.playoutUsageTimeEstimation !== -1">
                                    Time: {{ moment().startOf('day').seconds(license.playoutUsageTimeEstimation).format('HH:mm:ss') }}
                                </span>
                            </td>
                            <td>
                                <button class="btn btn-sm btn-outline-danger mr-2" @click="onDeleteLicense(license.id)" title="Delete license">
                                    <font-awesome-icon icon="trash"/>
                                </button>

                                <form class="form-inline d-inline-block mr-2"
                                      v-if="license.type === 'LICENSE_DEFAULT' && license.status !== 'LICENSE_ASSIGNED'"
                                      @submit.prevent="onUpdateLicense($event, license.id)">
                                    <select class="mr-2 form-control form-control-sm" name="license-status" required="required">
                                        <option value="">-- Status --</option>
                                        <option value="LICENSE_ACTIVE" v-if="license.status !== 'LICENSE_ACTIVE'">
                                            Active
                                        </option>
                                        <option value="LICENSE_ASSIGNED" v-if="license.status !== 'LICENSE_ASSIGNED'">
                                            Assigned
                                        </option>
                                    </select>
                                    <button class="btn btn-sm btn-outline-secondary" type="submit" title="Reset license">
                                        <font-awesome-icon icon="history"/>
                                    </button>
                                </form>

                                <router-link class="btn btn-sm btn-outline-info mr-2"
                                             title="License details"
                                             :to="'/licenses/' + license.id">
                                    <font-awesome-icon icon="info-circle"/>
                                </router-link>

                                <button v-if="license.party" class="btn btn-sm btn-outline-primary"
                                        title="View customer details"
                                        data-toggle="modal"
                                        data-target="#customer-details-modal"
                                        @click="onOpenCustomer(license.party)">
                                    <font-awesome-icon icon="user"/>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-12 clearfix">
                <pagination-component :page="page" :limit="limit" :total="licenses.total" @paginate="onChangePage"/>
            </div>
        </div>

        <!-- Customer Modal -->
        <modal-component id="customer-details-modal"
                         class="fade"
                         :title="'Customer: ' + customer.firstName + ' ' + customer.lastName + ''"
                         size="modal-lg">
            <div class="modal-body">

                <!-- MODAL SPINNER -->
                <div class="row mb-3 justify-content-center" v-if="Object.keys(customer).length === 0 || showModalSpinner === true">
                    <spinner-component class="p-5" type="spinner-grow"/>
                </div>

                <ul class="nav nav-tabs mb-4" id="customerModal" role="tablist" v-if="Object.keys(customer).length !== 0 && showModalSpinner === false">
                    <li class="nav-item">
                        <a class="nav-link active" id="details-tab" data-toggle="tab" href="#details" role="tab" aria-controls="details" aria-selected="true">
                            Details
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="licenses-tab" data-toggle="tab" href="#licenses" role="tab" aria-controls="licenses" aria-selected="true">
                            Licenses
                            <span class="badge badge-primary" v-if="customer.licenses">{{ customer.licenses.length }}</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="documents-tab" data-toggle="tab" href="#documents" role="tab" aria-controls="documents" aria-selected="false">
                            Documents
                            <span class="badge badge-primary" v-if="documents.list">{{ documents.list.length }}</span>
                        </a>
                    </li>
                </ul>

                <div class="tab-content mb-4" id="customerModalContent" v-if="Object.keys(customer).length !== 0 && showModalSpinner === false">

                    <!-- Details tab pane -->
                    <div class="tab-pane fade show active" id="details" role="tabpanel" aria-labelledby="details-tab">
                        <div class="container">

                            <div class="row mb-4">
                                <div class="col-12">
                                    <h4 class="h6">Customer</h4>
                                    <hr>
                                </div>
                                <div class="col-12">
                                    <div class="media mb-2 d-flex align-items-center">
                                        <v-gravatar class="rounded-circle mr-3" id="gravatar" :size="72" :email="customer.email"/>
                                        <div class="media-body">
                                            <h5 class="m-0 font-weight-bold">{{ customer.firstName + ' ' + customer.lastName }}</h5>
                                            <p class="text-muted mb-0"><a :href="'mailto:' + customer.email">{{ customer.email }}</a></p>
                                            <p class="text-muted mb-0">{{ customer.customerNumber }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-4">
                                <div class="col-4">
                                    <h3 class="h6">Customer group</h3>
                                    <hr>
                                    <button :class="getCustomerGroupClass(customer.type)"
                                            class="btn btn-sm btn-outline-success btn-block mb-2"
                                            disabled="disabled">
                                        <span v-if="customer.type === 'PERSON_CUSTOMER'">Customer</span>
                                        <span v-if="customer.type === 'PERSON_RESELLER'">Reseller</span>
                                    </button>
                                    <form @submit.prevent="onUpdateCustomerGroup($event)">
                                        <select class="form-control form-control-sm mb-2" name="customer-group">
                                            <option value="Customer" v-if="customer.type !== 'PERSON_CUSTOMER'">Customer</option>
                                            <option value="Reseller" v-if="customer.type !== 'PERSON_RESELLER'">Reseller</option>
                                        </select>
                                        <button type="submit" class="btn btn-sm btn-outline-primary btn-block">Update Customer Group</button>
                                    </form>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-6">
                                    <h3 class="h6">Billing Address</h3>
                                    <hr>

                                    <address class="mb-0">
                                        {{ customer.billingAddress.firstName }} {{ customer.billingAddress.lastName }}
                                        <br>
                                        {{ customer.billingAddress.street }}
                                        <br>
                                        {{ customer.billingAddress.postcode }}, {{ customer.billingAddress.city }}
                                        {{ customer.billingAddress.country }} {{ customer.billingAddress.state }}
                                    </address>
                                </div>

                                <div class="col-6">
                                    <h3 class="h6">Shipping Address</h3>
                                    <hr>

                                    <address class="mb-0">
                                        {{ customer.shippingAddress.firstName }} {{ customer.shippingAddress.lastName }}
                                        <br>
                                        {{ customer.shippingAddress.street }}
                                        <br>
                                        {{ customer.shippingAddress.postcode }}, {{ customer.shippingAddress.city }}
                                        {{ customer.shippingAddress.country }} {{ customer.shippingAddress.state }}
                                    </address>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- Licenses tab pane -->
                    <div class="tab-pane fade" id="licenses" role="tabpanel" aria-labelledby="licenses-tab">
                        <div class="container">

                            <!-- CUSTOMER LICENSES TABLE -->
                            <div class="row" v-if="showModalSpinner === false">
                                <div class="col-12" v-if="customer.licenses.length > 0">
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                            <th scope="col">License Code</th>
                                            <th scope="col">Type</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Actions</th>
                                            </thead>
                                            <tbody>
                                            <tr v-for="license in customer.licenses" :key="license.id">
                                                <td class="align-middle">{{ license.licenseCode }}</td>
                                                <td>
                                                <span class="badge badge-primary" v-if="license.type === 'LICENSE_RESELLER'">
                                                    Reseller
                                                </span>
                                                    <span class="badge badge-light" v-if="license.type === 'LICENSE_DEFAULT'">
                                                    Default
                                                </span>
                                                </td>
                                                <td>
                                                    <span v-if="license.status === 'LICENSE_USED'" class="badge badge-warning">
                                                        Used
                                                    </span>
                                                    <span v-else-if="license.status === 'LICENSE_ASSIGNED'" class="badge badge-success">
                                                        Assigned
                                                    </span>
                                                    <span v-else-if="license.status === 'LICENSE_UNASSIGNED'" class="badge badge-light">
                                                        Unassigned
                                                    </span>
                                                    <span v-else-if="license.status === 'LICENSE_CANCELLED'" class="badge badge-danger">
                                                        Cancelled
                                                    </span>
                                                    <span v-else-if="license.status === 'LICENSE_ACTIVE'" class="badge badge-info">
                                                        Active
                                                    </span>
                                                    <span v-else-if="license.status === 'LICENSE_WATCHING'" class="badge badge-dark">
                                                        <font-awesome-icon class="mr-1 small fa-blink" icon="play"/>
                                                        Watching
                                                    </span>
                                                    <span v-else class="badge badge-secondary">
                                                        {{ license.status }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-outline-danger mr-2" @click="onDeleteLicenseModal(license.id)" title="Delete license">
                                                        <font-awesome-icon icon="trash"/>
                                                    </button>

                                                    <a class="btn btn-sm btn-outline-info"
                                                       title="License details"
                                                       :href="'/licenses/' + license.id"
                                                       target="_blank"
                                                       rel="noopener noreferrer"
                                                       v-if="license.type === 'LICENSE_DEFAULT' && (license.status === 'LICENSE_WATCHING' || license.status === 'LICENSE_USED')">
                                                        <font-awesome-icon icon="info-circle" class="mr-1"/>
                                                        Details
                                                    </a>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <!-- NO CUSTOMER LICENSES ALERT -->
                            <div class="col-12 mb-3" v-if="customer.licenses.length === 0">
                                <div class="alert alert-info" role="alert">
                                    This customer does not have any licenses.
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- Documents tab pane -->
                    <div class="tab-pane fade" id="documents" role="tabpanel" aria-labelledby="documents-tab">
                        <div class="container">

                            <!-- MODAL CONTENT -->
                            <div class="row mb-3" v-if="showModalSpinner === false">

                                <!-- DOCUMENTS TABLE -->
                                <div class="col-12" v-if="documents.list !== undefined && documents.list.length > 0">
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                            <th>Name</th>
                                            <th>Status</th>
                                            <th>Type</th>
                                            <th>Actions</th>
                                            </thead>
                                            <tbody>
                                            <tr v-for="singleDocument in documents.list" :key="singleDocument.id">
                                                <td class="align-middle">{{ singleDocument.descShort }}</td>
                                                <td class="align-middle">
                                                    <span class="badge" :class="getDocumentStatusClass(singleDocument.status)">
                                                        {{ getDocumentStatusLabel(singleDocument.status) }}
                                                    </span>
                                                </td>
                                                <td class="align-middle">
                                                    <span class="badge" :class="getDocumentTypeClass(singleDocument.type)">
                                                        {{ getDocumentTypeLabel(singleDocument.type) }}
                                                    </span>
                                                </td>
                                                <td class="align-middle">
                                                    <a class="btn btn-sm btn-outline-primary mr-2" :href="singleDocument.url" title="Download">
                                                        <font-awesome-icon icon="download"/>
                                                    </a>
                                                    <button class="btn btn-sm btn-outline-danger" @click="onDeleteDocument(customer.id, singleDocument.descShort)">
                                                        <font-awesome-icon icon="trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <!-- NO DOCUMENTS ALERT -->
                                <div class="col-12 mb-3"  v-if="documents.list === undefined || documents.list.length === 0">
                                    <div class="alert alert-info" role="alert">
                                        This customer does not have any documents.
                                    </div>
                                </div>

                                <!-- CREATE DOCUMENTS -->
                                <div class="col-12">
                                    <form class="" @submit.prevent="onCreateDocument(customer.id)">
                                        <p class="text-muted">Create a document for this customer.</p>
                                        <div class="form-group mr-2">
                                            <select class="form-control" required="required" v-model="createDocumentType">
                                                <option value="SEAMLESS1_CERTIFICATE_SILVER_V1">I am Mounir Certificate - Silver</option>
                                                <option value="SEAMLESS1_CERTIFICATE_GOLD_V1">I am Mounir Certificate - Gold</option>
                                            </select>
                                        </div>
                                        <button class="btn btn-primary" type="submit">Create</button>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal-component>
    </default-layout>
</template>

<script>
    import DefaultLayout from "../components/layout/DefaultLayout";
    import SpinnerComponent from "../components/ui/SpinnerComponent";
    import PaginationComponent from "../components/PaginationComponent";
    import moment from "moment";
    import ModalComponent from "../components/ui/ModalComponent";

    export default {
        name: "LicensesPage",
        components: {ModalComponent, PaginationComponent, SpinnerComponent, DefaultLayout },
        computed: {
            keyNaveModule() {
                return this.$store.state.keyNave;
            },
            licenses() {
                return this.$store.state.keyNave.licenses;
            },
            customer() {
                return this.$store.state.cliffMarket.customer;
            },
            documents() {
                return this.$store.state.prismPeak.documents;
            }
        },
        data() {
            return {
                loading: true,
                page: 1,
                limit: 10,
                createDocumentType: undefined,
                filter: [
                    {
                        key: 'code',
                        value: ''
                    }
                ],
                showModalSpinner: false,
            }
        },
        methods: {
            moment(date) {
                return moment(date);
            },
            async onOpenCustomer(partyId) {
                this.showModalSpinner = true;

                await this.$store.dispatch('cliffMarket/getCustomer', partyId);
                await this.$store.dispatch('prismPeak/clearDocuments');
                await this.$store.dispatch('prismPeak/listDocuments', {
                    page: 1,
                    limit: 100,
                    filter: {
                        type: 'CUSTOMER',
                        id: partyId
                    }
                });

                this.showModalSpinner = false;
                this.$forceUpdate();
            },
            onRefresh() {
                let filter = [];

                if (this.filter[0].value) {
                    filter = this.filter;
                }

                this.$store.dispatch('keyNave/clearLicenses');
                this.$store.dispatch('keyNave/listLicenses', {
                    page: this.page,
                    limit: this.limit,
                    filter: filter
                });
            },
            onChangePage(page) {
                if (page <= 0) {
                    return;
                }

                this.page = parseInt(page);
                this.onRefresh();
            },
            async onUpdateLicense(event, licenseId) {
                this.loading = true;
                let filter = [];

                if (this.filter[0].value) {
                    filter = this.filter;
                }

                await this.$store.dispatch('keyNave/updateLicense', {
                    license: licenseId,
                    status:  event.target.elements['license-status'].value
                });

                await this.$store.dispatch('keyNave/listLicenses', {
                    page: this.page,
                    limit: this.limit,
                    filter: filter
                });

                this.loading = false;
                this.$forceUpdate();
            },
            async onCreateDocument(party) {
                this.showModalSpinner = true;

                await this.$store.dispatch('prismPeak/createDocument', {
                    party: party,
                    type: this.createDocumentType
                });
                await this.$store.dispatch('prismPeak/clearDocuments');
                await this.$store.dispatch('prismPeak/listDocuments', {
                    page: 1,
                    limit: 100,
                    filter: {
                        type: 'CUSTOMER',
                        id: party
                    }
                });

                this.showModalSpinner = false;
                this.$forceUpdate();
            },
            async onDeleteDocument(party, type) {
                this.showModalSpinner = true;

                await this.$store.dispatch('prismPeak/deleteDocument', {
                    party: party,
                    type: type
                });
                await this.$store.dispatch('prismPeak/clearDocuments');
                await this.$store.dispatch('prismPeak/listDocuments', {
                    page: 1,
                    limit: 100,
                    filter: {
                        type: 'CUSTOMER',
                        id: party
                    }
                });

                this.showModalSpinner = false;
                this.$forceUpdate();
            },
            async onDeleteLicense(licenseId) {
                this.loading = true;
                let filter = [];

                if (this.filter[0].value) {
                    filter = this.filter;
                }

                await this.$store.dispatch('keyNave/deleteLicense', licenseId);
                await this.$store.dispatch('keyNave/listLicenses', {
                    page: this.page,
                    limit: this.limit,
                    filter: filter
                });

                this.loading = false;
                this.$forceUpdate();
            },
            async onDeleteLicenseModal(licenseId) {
                this.showModalSpinner = true;
                let filter = [];

                if (this.filter[0].value) {
                    filter = this.filter;
                }

                await this.$store.dispatch('keyNave/deleteLicense', licenseId);
                await this.$store.dispatch('cliffMarket/getCustomer', this.customer.id);
                await this.$store.dispatch('keyNave/listLicenses', {
                    page: this.page,
                    limit: this.limit,
                    filter: filter
                });

                this.showModalSpinner = false;
                this.$forceUpdate();
            },
            async onUpdateCustomerGroup(event) {
                this.showModalSpinner = true;
                let filter = [];

                if (this.filter[0].value) {
                    filter = this.filter;
                }

                await this.$store.dispatch('cliffMarket/updateCustomerGroup', {
                    customer: this.customer.id,
                    groupName: event.target.elements['customer-group'].value
                });
                await this.$store.dispatch('cliffMarket/getCustomer', this.customer.id);
                await this.$store.dispatch('cliffMarket/clearCustomers');
                await this.$store.dispatch('cliffMarket/listCustomers', {
                    page: this.page,
                    limit: this.limit,
                    filter: filter
                });

                this.showModalSpinner = false;
                this.$forceUpdate();
            },

            exportCsv() {
                let exportData = [];
                let csvContent = "data:text/csv;charset=utf-8,";

                this.licenses.list.forEach(license => {
                    exportData.push({
                        LICENSE_ID: license.id,
                        LICENSE_CODE: license.licenseCode,
                        LICENSE_STATUS: license.status,
                        LICENSE_TYPE: license.type,
                        LICENSE_PURCHASE_DATE: license.purchaseDate,
                        LICENSE_ACTIVATION_DATE: license.activationDate,
                        LICENSE_ORDER_ID: license.order,
                        LICENSE_PRODUCT_ID: license.product,
                        LICENSE_PROJECT_ID: license.project,
                        LICENSE_RESELLER_LICENSE_COUNT: license.resellerLicenseCount,
                    });
                });

                csvContent += [
                    Object.keys(exportData[0]).join(";"),
                    ...exportData.map(license => Object.values(license).join(";"))
                ]
                    .join("\n")
                    .replace(/(^\[)|(\]$)/gm, "");

                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", "interactive-link-export-licenses-" + moment().format('YYYYMMDD-HHMMSS') + ".csv");
                link.click();
            },
            getCustomerGroupClass(group) {
                return {
                    'btn-outline-success': group === 'PERSON_CUSTOMER',
                    'btn-outline-info': group === 'PERSON_RESELLER'
                };
            },
            getDocumentStatusClass(status) {
                switch (status) {
                    case 'DOCUMENT_ACTIVE':
                        return 'badge-primary';
                    default:
                        return 'badge-light';
                }
            },
            getDocumentStatusLabel(status) {
                switch (status) {
                    case 'DOCUMENT_ACTIVE':
                        return 'Active';
                    default:
                        return status;
                }
            },
            getDocumentTypeClass(type) {
                switch (type) {
                    case 'DOCUMENT_CERTIFICATE':
                        return 'badge-success';
                    default:
                        return 'badge-light';
                }
            },
            getDocumentTypeLabel(type) {
                switch (type) {
                    case 'DOCUMENT_CERTIFICATE':
                        return 'Certificate';
                    default:
                        return type;
                }
            },
        },
        beforeMount() {
            if (Object.prototype.hasOwnProperty.call(this.$route.query, 'page')) {
                const page = parseInt(this.$route.query.page);
                this.page = page ? page : 1;
            }

            if (Object.prototype.hasOwnProperty.call(this.$route.query, 'limit')) {
                const limit = parseInt(this.$route.query.limit);
                this.limit = limit ? limit : 10;
            }

            if (this.$store.state.keyNave.status.listLicensesComplete === false) {
                let filter = [];

                if (this.filter[0].value) {
                    filter = this.filter;
                }                

                this.$store.dispatch('keyNave/listLicenses', {
                    page: this.page,
                    limit: this.limit,
                    filter: filter
                });
            }

            this.loading = false;
        }
    }
</script>

<style scoped>

</style>